import { handleCustomerResponse } from './helper_actions';
import { setCustomer } from './customer';
import { setComputedCart } from './computed_cart';
import { getCookie } from '../shared/cookie.js';
import { setFeedback, delayedClearFeedback, clearFeedback } from './feedback';
import {addToWishlistO, removeFromWishlist} from '../shared/wishlist.js';
import { MAX_CART_ITEM } from '../shared/cart';
import { checkIfProductInStore } from './cart_actions';
import request from 'superagent';


export function addProductToWishlist(oProduct) {
    // Optimistically update state right away
    return (dispatch, getState) => {
      if (!checkIfProductInStore(oProduct, getState().genres, getState().categories, getState().featured )) {
        console.warn('No store match found for product id ' + oProduct.id + '.');
        return dispatch([
          setFeedback("This product isn't in this club."),
          delayedClearFeedback()
        ]);
      }
      let oCustomer = getState().customer;
      oCustomer.wishlist = addToWishlistO(oProduct, oCustomer.wishlist);
      dispatch( setCustomer( oCustomer ));
      request
        .put('/svc/wishlist/' + oProduct.id + '/' + oProduct.format )
        .end((err, res) => {
          if (err || res.statusCode !== 200) {
            let feedbackText = (res.statusText) ? res.statusText : ('Could not add ' + oProduct.title + ' to your wishlist.');
            return dispatch([
              setFeedback(feedbackText),
              delayedClearFeedback()
            ]);
          }
        });
    }
  }

export function removeProductFromWishlist(oProduct) {
    // Optimistically update state right away
    return (dispatch, getState) => {
      let oCustomer = getState().customer;
      oCustomer.wishlist = removeFromWishlist(oProduct, oCustomer.wishlist);
      dispatch( setCustomer( oCustomer ));
      request
        .del('/svc/wishlist/' + oProduct.id + '/' + oProduct.format )
        .end((err, res) => {
          let sFeedback = err || res.statusCode !== 200
            ? 'Could not remove ' + oProduct.title + ' from your wishlist.'
            : oProduct.title + ' has been removed from your wishlist.';
          return dispatch( handleCustomerResponse(res, sFeedback) );
        });
    }
}


export function moveProductToCart(oProduct) {
    // If customer has 3 or fewer cart items, move item to cart
    return (dispatch, getState) => {
      if (!checkIfProductInStore(oProduct, getState().genres, getState().categories, getState().featured )) {
        console.warn('No store match found for product id ' + oProduct.id + '.');
        return dispatch([
          setFeedback("This product isn't in this club."),
          delayedClearFeedback()
        ]);
      }

      let oCart = getState().customer.cart;
      let bCanAdd = false;
      let isFeaturedBook = getState().featured.find(e => e.id == oProduct.id );
      let isNegOp = getState().store.type == "Negative Option";

      let oFakeEvent = {
        preventDefault: () => {/* noop */},
        currentTarget: { pathname: '/catalog' }
      };

      // check for open cart positions
      if ( ( !isNegOp && (oCart.length < MAX_CART_ITEM || (!oCart[0] && isFeaturedBook))) || (isNegOp && oCart.filter( x => x ).length < MAX_CART_ITEM)) {
        if (oCart[0] && isFeaturedBook && !isNegOp){
          var exFeedback = 'Sorry, but you can only add one featured item to your box.';
        } else bCanAdd = true;
      }

      if (bCanAdd) {
        request
          .put('/svc/wishlist/cart/' + oProduct.id +  '/' + oProduct.format + '/1' )
          .end((err, res) => {
            if (err || res.statusCode !== 200) {
              let feedbackText = (res.statusText) ? res.statusText : ('Could not move ' + oProduct.title + ' to your box.');
              return dispatch([
                setFeedback(feedbackText),
                delayedClearFeedback()
              ]);
            }
            let computedCart = getState().computedCart,
                cart = computedCart.items.filter( prod => prod ).map( prod => prod.mmid ).join(',');
            window.dataLayer.push({ 'event': 'addproduct', 'products': cart, 'value': computedCart.total });
            return dispatch([
              handleCustomerResponse( res, oProduct.title + ' has been moved to your box.' ),
              setComputedCart(res.body, computedCart, []),
            ]);
          });
      } else {
        let sFeedback = exFeedback !== undefined ? exFeedback : ( (oCart[0] && !isNegOp) || (isNegOp)
        ? 'You cannot place more than 4 items in your box.'
          : 'You cannot place more than 3 catalog items in your box. Add a Featured Selection!');
        dispatch([
          setFeedback(sFeedback),
          delayedClearFeedback()
        ]);
      }
    }
  }



// WEBPACK FOOTER //
// ./src/modules/wishlist_actions.js